<script lang="ts">
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import SkeletonBlock from '$lib/components/atoms/skeleton/SkeletonBlock.svelte';
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';
	import CarButton from '$lib/components/itinerary/options/cars/CarButton.svelte';

	interface Props {
		title?: string;
		infos?: string;
		badge?: string;
		selected?: boolean;
		isLoading?: boolean;
		onclick?: () => void;
	}

	const {
		title,
		infos,
		badge,
		selected = false,
		isLoading = false,
		onclick,
	}: Props = $props();
</script>

<CarButton {selected} {onclick}>
	<div class="text-body text-md w-full">
		<div class="text-bold truncate w-full">
			{#if isLoading}
				<SkeletonText minWords={2} maxWords={3} minWordLength={8} maxWordLength={12} />
			{:else}
				{title}
			{/if}
		</div>
		{#if isLoading}
			<SkeletonText minWords={1} maxWords={1} minWordLength={8} maxWordLength={15} />
		{:else if infos}
			<div class="truncate w-full">{infos}</div>
		{/if}
	</div>
	<div class="w-full">
		{#if isLoading}
			<SkeletonBlock height="16px" width="60px" />
		{:else if badge}
			<Badge size="sm" text={badge} color={selected ? 'car' : 'carInverted'} isSquare />
		{/if}
	</div>
</CarButton>
